import { lazy } from 'solid-js'
import { messages } from '../../pages/adaptive-injection-privacy-page/adaptive-injection-privacy-page.messages.en.js'

export default {
    component: lazy(() => import('../../pages/adaptive-injection-privacy-page/adaptive-injection-privacy-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/adaptive-injection-privacy-policy',
    titleMessage: messages.titleMessage,
}
